<template>
	
    <div class="vpay__content-area" v-loading="loading">
		
		<h2 class="vpay__title-bar"><ion-icon class="vpay__title-bar-close" name="arrow-back" @click="onClickClose"></ion-icon>Log In</h2>
		
		<div>
			
			<el-row>
				
				<el-col :span="24">
					<div class="vpay__input-container">
						<label>Email Address</label>
						<input class="vpay__input vpay__input--small" type="text" v-model="email">
					</div>
				</el-col>
				
				<el-col :span="24">
					<div class="vpay__input-container">
						<label>Password</label>
						<input class="vpay__input vpay__input--small" type="password" v-model="password">
					</div>
				</el-col>
				
			</el-row>
			
			<div class="vpay__input-container">
				<el-button class="vpay__next-button" type="success" @click="onClickLogIn" round>Log In</el-button>
			</div>
			
		</div>
		
    </div>
	
</template>

<script>
	
	import JWT from "@/mixins/jwt";
	
    export default {
		
        name: "LogIn",
		
		mixins: [ JWT ],
		
		methods: {
			
			onClickLogIn() {
				
				this.loading = true;
				
				this.axios.post(`${process.env.VUE_APP_USERS_API_URL}login`, { username: this.email, password: this.password }, { headers: this.$store.getters.requestHeaders2 }).then((r) => {
					if (r.data.success) {
						// Store the jwt token.
						this.$store.commit("jwt", r.headers.authorization);
						// If the decoded jwt token has a data.user property
						// store that as the logged in user's data.
						try {
							const decodedJwtToken = this.parseJwtToken(r.headers.authorization);
							if (decodedJwtToken.hasOwnProperty("data") && decodedJwtToken.data.hasOwnProperty("user")) {
								this.$store.commit("user", decodedJwtToken.data.user);
								this.$store.commit("address", {
									street_1: this.$store.getters.user.street_1,
									city: this.$store.getters.user.city,
									state: this.$store.getters.user.state,
									postcode: this.$store.getters.user.postcode,
									country: this.$store.getters.user.country,
								});
							}
						} catch (e) {
							
						} finally {
							
						}
						// Close the login form.
						this.$store.commit("displayComponentName", null);
					}
				}).catch((e) => {
					this.loading = false;
					this.$message.warning(e.response.data.message);
				});
				
			},
			
			onClickClose() {
				this.$store.commit("displayComponentName", null);
			}
			
		},
		
		data() {
			
			return {
				
				loading: false,
				
				email: "",
				password: "",
				
			};
			
		}
		
    }
	
</script>

<style>
	
	
	
</style>
